import { render, staticRenderFns } from "./HistoricalElectricity027Page.vue?vue&type=template&id=39f46ccc&"
import script from "./HistoricalElectricity027Page.vue?vue&type=script&lang=js&"
export * from "./HistoricalElectricity027Page.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalElectricity027Page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports